import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LANGS = [
  { code: "en", short: "EN", label: "English" },
  { code: "hi", short: "हि", label: "हिन्दी" },
  { code: "mr", short: "मरा", label: "मराठी" },
] as const;

export function LanguageToggle() {
  const { i18n, t } = useTranslation();
  const current = (i18n.language || "en").slice(0, 2);
  const cur = LANGS.find((l) => l.code === current) ?? LANGS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={`${t("nav.language")}: ${cur.short}`}
        className="inline-flex h-10 min-w-[3.25rem] items-center justify-center gap-1.5 border border-border bg-background px-2.5 font-mono text-[11px] font-semibold uppercase tracking-widest text-foreground transition-colors hover:border-foreground"
      >
        <Globe className="size-3.5" />
        <span>{cur.short}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => i18n.changeLanguage(l.code)}
            className="cursor-pointer justify-between font-sans text-sm"
          >
            <span>{l.label}</span>
            {l.code === current && <Check className="size-4 text-accent" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
